export enum CollapsibleTriggerDataAttributes {
  /**
   * Present when the collapsible panel is open.
   */
  panelOpen = 'data-panel-open',
}
